import React, { useState } from 'react';
import IOSPickerWheel from './IOSPickerWheel';
import NumberInputMode from './NumberInputMode';
import ModeToggleButton from './ModeToggleButton';
import { useIntegerInputLogic } from './useIntegerInputLogic';
import { generateValues } from './utils';
import '../IntegerInput.scss';

const IntegerInput = ({
  id,
  name,
  value = 1,
  onChange,
  min = 1,
  max = 1000,
  unit = '',
  disabled = false,
  className = '',
  error = false,
  required = false,
  ...props
}) => {
  const [mode, setMode] = useState('wheel'); // 'wheel' or 'input'
  const [values] = useState(() => generateValues(min, max));

  const {
    currentValue,
    handleValueChange,
    handleIncrement,
    handleDecrement
  } = useIntegerInputLogic({
    value,
    min,
    max,
    values,
    name,
    onChange
  });

  return (
    <div className={`integer-input ${className} ${error ? 'error' : ''}`}>
      <div className="integer-input__container">
        <div className="integer-input__content">
          {mode === 'wheel' ? (
            <IOSPickerWheel
              values={values}
              selectedValue={currentValue}
              onValueChange={handleValueChange}
              unit={unit}
              disabled={disabled}
            />
          ) : (
            <NumberInputMode
              id={id}
              name={name}
              value={currentValue}
              onChange={handleValueChange}
              min={min}
              max={max}
              unit={unit}
              disabled={disabled}
              required={required}
              values={values}
              onIncrement={handleIncrement}
              onDecrement={handleDecrement}
              {...props}
            />
          )}
        </div>

        <ModeToggleButton
          mode={mode}
          onToggle={setMode}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default IntegerInput;
